import { gql } from 'Utils/apolloClient'
import InstallmentDataFragment from './installmentDataFragment'

const installmentItemDeleteMutation = gql`
  mutation InstallmentItemDelete($installmentId: ID!, $isEngineAdmin: Boolean!, $itemId: ID!) {
    installmentItemDelete(input: { installmentId: $installmentId, isEngineAdmin: $isEngineAdmin,
                                   itemId: $itemId }) {
      installment {
        ...installmentData
      }
    }
  }

  ${InstallmentDataFragment}`

export default installmentItemDeleteMutation
